import { SearchCardMovementsRequest } from 'core/models/SearchCardMovementsRequest';
import { useCoreService } from 'core/services/useCoreService';
import { CardTotalsReportContext } from 'core/tarjeta/contexts/CardTotalsReportContext';
import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { useContext } from 'react';
import { Periodo } from 'shared/models/Periodo';
import { withPagination } from 'shared/table/hoc/withPagination';
import { Pageable } from 'shared/table/models/Pageable';
import { CardMovementsTable } from '../CardMovementsTable/CardMovementsTable';

const TableWithPagination = withPagination<Movimiento>(CardMovementsTable);

export const CardMovementsTableWithPagination = (props: {
  movimientos: Pageable<Movimiento>;
  rubroId?: number;
  periodo?: Periodo;
}) => {
  const { cardData } = useContext(CardTotalsReportContext);
  const coreService = useCoreService();

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<Movimiento>> => {
    const searchParams = new SearchCardMovementsRequest({
      numeroTarjeta: cardData.numeroTarjeta,
      rubroId: props.rubroId,
      page: status.pageNumber,
      size: status.pageSize,
      anio: props.periodo?.anio,
      mes: props.periodo?.mes,
    });
    const response = await coreService.getCardMovements(searchParams);
    return response.body;
  };

  return (
    <TableWithPagination
      pageableInit={props.movimientos}
      dataFetcherFunction={onChangePaginationStatus}
    ></TableWithPagination>
  );
};
